import TestUI from "./TestUI";
import { PosturalExamination, PosturalTestDefinition } from "./interfaces";
import { photoNotTakenYet, TakenPhoto } from "./PosturalExamWrapper";

const PosturalExamRateRight = ({
  page,
  testDefinitions,
  posturalExamination,
  setTestSelection,
  justCreated,
}: {
  page: number;
  testDefinitions: PosturalTestDefinition[];
  posturalExamination: PosturalExamination;
  setTestSelection: Function;
  justCreated: boolean;
}) => {
  if (testDefinitions && testDefinitions.length > 0)
    testDefinitions.sort((td1, td2) => td1.id - td2.id);

  return (
    <>
      {page == 0 && (
        <>
          <TestUI
            testDefinition={
              testDefinitions.length > 0 ? testDefinitions[0] : undefined
            }
            testSelection={
              posturalExamination.testSelections &&
              posturalExamination.testSelections.length > 0
                ? posturalExamination.testSelections[0]
                : undefined
            }
            setTestSelection={setTestSelection}
          />
          <TestUI
            testDefinition={
              testDefinitions.length > 1 ? testDefinitions[1] : undefined
            }
            testSelection={
              posturalExamination.testSelections &&
              posturalExamination.testSelections.length > 1
                ? posturalExamination.testSelections[1]
                : undefined
            }
            setTestSelection={setTestSelection}
          />
          <TestUI
            testDefinition={
              testDefinitions.length > 2 ? testDefinitions[2] : undefined
            }
            testSelection={
              posturalExamination.testSelections &&
              posturalExamination.testSelections.length > 2
                ? posturalExamination.testSelections[2]
                : undefined
            }
            setTestSelection={setTestSelection}
          />
        </>
      )}
      {page == 1 && (
        <>
          <TestUI
            testDefinition={
              testDefinitions.length > 3 ? testDefinitions[3] : undefined
            }
            testSelection={
              posturalExamination.testSelections &&
              posturalExamination.testSelections.length > 3
                ? posturalExamination.testSelections[3]
                : undefined
            }
            setTestSelection={setTestSelection}
          />
          <TestUI
            testDefinition={
              testDefinitions.length > 4 ? testDefinitions[4] : undefined
            }
            testSelection={
              posturalExamination.testSelections &&
              posturalExamination.testSelections.length > 4
                ? posturalExamination.testSelections[4]
                : undefined
            }
            setTestSelection={setTestSelection}
          />
        </>
      )}
      {page == 2 && (
        <>
          <TestUI
            testDefinition={
              testDefinitions.length > 5 ? testDefinitions[5] : undefined
            }
            testSelection={
              posturalExamination.testSelections &&
              posturalExamination.testSelections.length > 5
                ? posturalExamination.testSelections[5]
                : undefined
            }
            setTestSelection={setTestSelection}
          />

          <TestUI
            testDefinition={
              testDefinitions.length > 6 ? testDefinitions[6] : undefined
            }
            testSelection={
              posturalExamination.testSelections &&
              posturalExamination.testSelections.length > 6
                ? posturalExamination.testSelections[6]
                : undefined
            }
            setTestSelection={setTestSelection}
          />
        </>
      )}
      {page == 3 && (
        <>
          <TestUI
            testDefinition={
              testDefinitions.length > 7 ? testDefinitions[7] : undefined
            }
            testSelection={
              posturalExamination.testSelections &&
              posturalExamination.testSelections.length > 7
                ? posturalExamination.testSelections[7]
                : undefined
            }
            setTestSelection={setTestSelection}
          />
          <TestUI
            testDefinition={
              testDefinitions.length > 8 ? testDefinitions[8] : undefined
            }
            testSelection={
              posturalExamination.testSelections &&
              posturalExamination.testSelections.length > 8
                ? posturalExamination.testSelections[8]
                : undefined
            }
            setTestSelection={setTestSelection}
          />
          <TestUI
            testDefinition={
              testDefinitions.length > 9 ? testDefinitions[9] : undefined
            }
            testSelection={
              posturalExamination.testSelections &&
              posturalExamination.testSelections.length > 9
                ? posturalExamination.testSelections[9]
                : undefined
            }
            setTestSelection={setTestSelection}
          />
        </>
      )}
    </>
  );
};

export default PosturalExamRateRight;
